<template>
  <div class="page" style="margin:0 0 120px;">
    <div class="banner">
      <div
        class="banner-img"
        style="background-image:url(https://static.wkanx.com/w002/M00/05/B4/CgIXGF6EQLKAGLuPAAAyrxDMvNs245.jpg)"
      ></div>
      <div class="abs-center-hv">
        <el-input placeholder="输入您要查询的代理商名称" v-model="name" style="width:326px;">
          <el-button slot="append" icon="el-icon-search">查询</el-button>
        </el-input>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  props: {},
  data() {
    return {
      name: '',
    };
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped></style>
